export default __webpack_public_path__ + "static/media/white-sweet1.b4b25af7.jpg";